export const isEqualDeep = (a, b) => JSON.stringify(a) === JSON.stringify(b);
